module.exports = __webpack_public_path__ + "img/sending_6.a1710264.png";